import z from "zod/v4";

export const MinecraftGameModeSchema = z.enum([
  "survival",
  "creative",
  "adventure",
]);

export const MinecraftGameMode = {
  Survival: "survival",
  Creative: "creative",
  Adventure: "adventure",
} satisfies Record<string, MinecraftGameMode>;

export type MinecraftGameMode = z.infer<typeof MinecraftGameModeSchema>;
